import { Navigate, Outlet } from 'react-router-dom';

import { useIsAuth } from '@hooks/user/useIsAuth';

export const PublicRoute = () => {
  const isAuth = useIsAuth();

  if (isAuth) {
    return <Navigate to="/batches" replace />;
  }

  return <Outlet />;
};
